import React, { useState, useEffect } from "react";
import { Box, Button, Card, Text, Spinner, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import NavBar from "../../Components/Navbar/NavBar";
import DataTable from "react-data-table-component";
import axios from "axios";
import { handleAuthError } from "../../utils/auth";
import CardsStore from "./CardsStore";

const BrandsManagement = ({ currentUserId }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const [brandsStore, setBrandsStore] = useState([
    {
      brandName: "KR",
      brandId: 1,
      color: "orange",
      Stores: [],
    },
    {
      brandName: "SBC",
      brandId: 2,
      color: "red",
      Stores: [],
    },
    {
      brandName: "PB",
      brandId: 3,
      color: "blue",
      Stores: [],
    },
    {
      brandName: "JB",
      brandId: 4,
      color: "green",
      Stores: [],
    },
    {
      brandName: "RJ",
      brandId: 5,
      color: "gray",
      Stores: [],
    },
    {
      brandName: "LAC",
      brandId: 6,
      color: "red",
      Stores: [],
    },
    {
      brandName: "CN",
      brandId: 7,
      color: "pink",
      Stores: [],
    },
    {
      brandName: "KT",
      brandId: 8,
      color: "red",
      Stores: [],
    },
    {
      brandName: "GL",
      brandId: 9,
      color: "orange",
      Stores: [],
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [trigger, setTrigger] = useState(false);
  // Function to refresh stores for a specific brand
  const refreshBrandStores = async (brandId) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/maintenance/getBrands`,
        { brandId: brandId },
      );

      // Update only the specific brand's stores
      setBrandsStore((prevBrands) =>
        prevBrands.map((brand) =>
          brand.brandId === brandId
            ? { ...brand, Stores: response.data }
            : brand,
        ),
      );
    } catch (error) {
      // Check for authentication errors first
      if (error.response && error.response.status === 401) {
        handleAuthError(toast, navigate);
        return;
      }

      console.error("Error fetching stores:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchStores = async () => {
      setIsLoading(true);
      try {
        // Fetch stores for each brand
        const updatedBrands = await Promise.all(
          brandsStore.map(async (brand) => {
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_API_URL}/maintenance/getBrands`,
              { brandId: brand.brandId },
            );
            // Return the brand with updated Stores
            return {
              ...brand,
              Stores: response.data,
            };
          }),
        );

        // Update the state with the fetched data
        setBrandsStore(updatedBrands);
      } catch (error) {
        // Check for authentication errors first
        if (error.response && error.response.status === 401) {
          handleAuthError(toast, navigate);
          return;
        }

        console.error("Error fetching stores:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStores();
  }, [trigger]);
  return (
    <>
      <NavBar inManagement />
      <Box width={"100%"} display={"flex"} flexDirection={"column"}>
        <Text
          fontSize={{ base: "2xl", lg: "3xl" }}
          fontWeight={"bold"}
          textAlign={"left"}
          mt={4}
          ml={6}
        >
          Brand Management
        </Text>
        <Box display={"flex"} flexDirection={"column"}>
          {brandsStore.map((store) => (
            <CardsStore
              key={store.brandId}
              data={store}
              isLoading={isLoading}
              trigger={() => refreshBrandStores(store.brandId)}
            />
          ))}
        </Box>
      </Box>
    </>
  );
};

export default BrandsManagement;
